<template>
<div class="container">
	<h2>Permissions: {{ employee.first_name }} {{ employee.last_name }}</h2>

	<form v-if="$route.params.id != $store.userSlug">

		<h3>User Type</h3>
		
		<field label="Authorization Type" col-class="col-md-4"
			:params="{
				type: 'btn-group',
				buttons: [
					{
						text: 'Admin',
						value: 'Admin'
					},
					{
						text: 'Basic',
						value: 'Basic'
					},
					{
						text: 'Light',
						value: 'Light'
					},
					{
						text: 'Suspended',
						value: 'Suspended'
					}
				]
			}"
			v-model="roleType"
			v-on:change="save"></field>
		<p class="form-text"><strong>Admin</strong> user's don't need any special permissions. They can view and modify all records. <strong>Light</strong> users are the most basic type of user, and will see a stripped down version of the UI.</p>

		<h3>Module Permissions</h3>

		<p>Module permissions are system-wide permissions and should be used sparingly. Anyone with read or write permission for a specific module will be able to read or write ALL records belonging to that module.</p>

		<p v-if="roleType == 'Admin'">Admin users don't need any special module-based permissions.</p>

		<p v-else-if="roleType == 'Light'">Light users cannot be assigned module-based permissions.</p>

		<div v-else-if="modulePermissions" class="row">
			<div class="col-md-4">
				<field label="Apply a Permissions Template" col-class="stacked" :params="{type:'btn-group',buttons:permTemplateButtons}" v-on:change="applyPermTemplate"></field>
			</div>
			<div class="col-md-8">
				<module-permssion-control
					v-for="module in enabledModules" 
					:module-name="module"
					:module-permissions="modulePermissions"
					:key="module"
					v-on:permsChanged="save">
				</module-permssion-control>
			</div>
		</div>
		

	</form>
	<p v-else>You can't change your own permissions.</p>
</div>
</template>

<script>

import ModulePermssionControl from "@/components/ModulePermssionControl"
import Field from "@/components/Field"

export default {

	name: 'EmployeePermissions',
	components: {
		Field,
		ModulePermssionControl
	},
	data() {
		return {
			employee: {},
			roleType: "",
			modulePermissions: {},
			enabledModules: [],
			permissionTemplates: []
		}
	},
	computed: {
		permTemplateButtons() {
			return this.permissionTemplates.map(template => {
				return {
					text: template.title,
					value: template
				}
			})
		}
	},
	methods: {
		save(perms) {

			let payload = {
				user_id: this.employee.id,
				role_type: this.roleType,
				module_permissions: JSON.stringify(this.modulePermissions)
			}

			this.saveRecord("UserPermission",payload)
		},
		applyPermTemplate(value) {
			let vm = this

			this.$nextTick(() => {
				vm.modulePermissions = JSON.parse(value.module_permissions)

				vm.save()
			})
		},
		fetchData() {
			let vm = this

			let includes = JSON.stringify(["UserPermission"]);

			Promise.all([
				this.getJSON("User/find/"+this.$route.params.id+"?include="+includes),
				this.getJSON("Module/get"),
				this.getJSON("PermissionTemplate/get")
			]).then(function(responses){

				vm.employee = responses[0].data

				if (responses[0].data.UserPermission.length > 0)
					vm.roleType = responses[0].data.UserPermission[0].role_type

				vm.enabledModules = responses[1].data

				if (responses[0].data.UserPermission.length > 0 && 
					responses[0].data.UserPermission[0].module_permissions) {
					
					vm.modulePermissions = JSON.parse(responses[0].data.UserPermission[0].module_permissions)

				}

				vm.enabledModules.forEach(function(mod,index){
					//loop through each module and check if it exists in the module permissions object yet, if not, add with read/write as false

					if (!(mod in vm.modulePermissions)) {

						vm.$set(vm.modulePermissions,mod,{
							read: false,
							write: false
						})
					}
				})

				vm.permissionTemplates = responses[2].data

				vm.spinner(false)

			})

		},
	},
	created() {
		this.spinner(true)
		this.fetchData();
	}

}
</script>

<style type="text/css">

</style>